const { reportErrorToFaro } = require('@sendible/common');

let Sendible;
const sendible_service_created = function () {};
let sendible_login = '';
let sendible_api_key = '';
const sendible_site_code = '';
let sendible_application_id = '';
const base_api_url = WEBPACK_API;
const rr_accessToken = 'aeb998b742f733ef31e0c6a68633e2949774c2d88f44ba857aaba97b4f40e249';
const rr_apiUrl = 'http://api.rightrelevance.com';

window.Sendible = Sendible = window.Sendible || {};
window.sendible_service_created = sendible_service_created;
window.sendible_login = sendible_login;
window.sendible_api_key = sendible_api_key;
window.sendible_site_code = sendible_site_code;
window.sendible_application_id = sendible_application_id;
window.base_api_url = base_api_url;
window.rr_accessToken = rr_accessToken;
window.rr_apiUrl = rr_apiUrl;

if (base_api_url == WEBPACK_API
    || location.protocol.indexOf('https') !== -1) {
  window.api_url = `https://${base_api_url}`;
} else {
  window.api_url = `http://${base_api_url}`;
}

Sendible.Connect = {};
Sendible.rightRelevance = {};

Sendible.convertFBTAgs = function (comment) {
  let key;
  const arMsgTags = [];
  // normalise message_tags
  if (!$.isArray(comment.message_tags)) {
    // eslint-disable-next-line no-restricted-syntax,  guard-for-in
    for (key in comment.message_tags) {
      arMsgTags.push(comment.message_tags[key][0]);
    }
    comment.message_tags = arMsgTags;
  }

  // loop thru message_tags and replace word to fb tags
  // order by offset
  comment.message_tags.sort((a, b) => {
    if (a.offset > b.offset) { return -1; }
    if (a.offset < b.offset) { return 1; }
    return 0;
  });

  // e.g test wired message with fb tag
  _.each(comment.message_tags, (tag) => {
    let messageProperty;
    let nameWithCode;
    let searchIndex = 0;
    const HASHTAG = '#';
    let setSubjectUnformated = false;

    if (comment.message_no_html && comment.message_no_html !== '') {
      messageProperty = 'message_no_html';
      if (comment.message_no_html === comment.subject_unformatted) {
        // if message_no_html equla subject_unformatted then set to same value
        setSubjectUnformated = true;
      }
    } else {
      messageProperty = 'message';
    }

    const tmpMsg = comment[messageProperty];

    for (searchIndex; searchIndex < 5; searchIndex++) {
      if ((tmpMsg.substr(tag.offset + searchIndex)).indexOf(tag.name) == 0 && tag?.name && !tag.name.includes(HASHTAG)) {
        nameWithCode = `@[${tag.name}:${tag.id}]`;
        comment[messageProperty] = tmpMsg.substr(0, tag.offset + searchIndex) + nameWithCode + tmpMsg.substr(tag.offset + searchIndex + tag.length);
        break;
      }
    }

    if (messageProperty == 'message_no_html' && comment.message_unformatted) {
      comment.message_unformatted = comment.message_no_html;
      if (setSubjectUnformated) {
        comment.subject_unformatted = comment.message_no_html;
      }
    }
  });
};

Sendible.applyFBTags = function (data) {
  if (data && data.messages && data.messages.length) {
    _.each(data.messages, (msg) => {
      if (msg.comments && msg.comments.length) {
        _.each(msg.comments, (comment) => {
          if (comment.message_tags && comment.message_tags.length) {
            Sendible.convertFBTAgs(comment);
          }

          if (comment.comments && comment.comments.length) {
            _.each(comment.comments, (comment1) => {
              if (comment1.message_tags && comment1.message_tags.length) {
                Sendible.convertFBTAgs(comment1);
              }
            });
          }
        });
      }

      if (msg.message_tags && !$.isEmptyObject(msg.message_tags)) {
        Sendible.convertFBTAgs(msg);
      }
    });
  }
};

Sendible.getApplicationId = function () {
  if (api_url.indexOf('sendible') !== -1) {
    return 'sendible_global';
  }
  return 'whitelabel_global';
};

// helper method for passing data
Sendible.Connect.dataParse = function (data, onSuccess, onError, context) {
  let parseData = data;

  if (typeof onSuccess === 'undefined') onSuccess = function () { };
  if (typeof onError === 'undefined') onError = function () { };

  if (!data) {
    parseData = {};
    data = {};
  }

  if (data.statusText && data.responseText && data.status
        && (data.statusText === 'error'
            || data.status >= 400
        )) {
    if (data.responseText.toLowerCase().indexOf('<!doctype') == -1) {
      try {
        data = JSON.parse(data.responseText);
      } catch (error) {
        reportErrorToFaro(error, 'SendibleConnect dataParse');

        data = {
          error: 'Unidentified error',
        };
      }
    }

    onError(data);
    return;
  }

  if ((data.error && onError && typeof context !== 'undefined')
        || typeof data === 'undefined'
        || data.type === 'MessageError') {
    // should catch API that return sucessful but with an error message
    if ((data && (data.error && data.error.hasOwnProperty('type')))
            || (data && (data.error && data.error.hasOwnProperty('code')))
            || (data && (data.type && data.type == 'MessageError'))) {
      onError(data);

      // if context has a url and config is set to record errors
    } else if (context && context.hasOwnProperty('url') && window.appConfig.logApiErrors) {
      if (data.state && data.state() === 'rejected') {
        if (data.statusText == 'Internal Server Error' || data.statusText == 'Bad Request' || data.statusText == 'error') {
          onError(parseData);
        }
      }

      // if error is not returned by the server and error reporting is switched off then run the backbone error handling
    } else {
      onError(parseData);
    }
  } else {
    onSuccess(data);
  }
};

// helper method for formating into parameters
Sendible.Connect.convertIntoParameterFormat = function (obj) {
  const arPairs = _.pairs(obj);

  return _.map(arPairs, (val) => ({
    parameter_name: val[0],
    parameter_value: val[1],
  }));
};

// helper method for formating into parameters
Sendible.Connect.convertFromParameterFormat = function (arrObj) {
  const jsObj = {};
  _.each(arrObj, (val) => {
    jsObj[val.parameter_name] = val.parameter_value;
  });

  return jsObj;
};

Sendible.Connect.getSiteInfo = function (application_id1, url, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();

  const params = {
    url,
    application_id,
  };

  $.ajax({
    url: `${api_url}/api/utils/site_lookup.json?`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// Profile : GET : https://code.google.com/p/sendible-api/wiki/Profile
Sendible.Connect.profileTokenTest = function (accessToken, onSuccess, onError) {
  $.ajax({
    url: `${api_url}/api/v2/profile.json?access_token=${accessToken}&version=1.1`,
    data: {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.getServices = function (application_id1, options, filter, page, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = options;

  params.application_id = application_id;
  params.filter = filter;
  params.page = page;

  if (params.per_page) {
    params.per_page = parseInt(params.per_page, 10);

    if (params.per_page > 3500) {
      params.per_page = 3500;
    }
  } else {
    params.per_page = 3500;
  }

  sendible_application_id = application_id;

  return $.ajax({
    url: `${api_url}/1.0/api/services?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.getInboxServices = function (application_id1, username, password, onSuccess, onError) {
  const params = {};
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  sendible_application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/inbox_services.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// https://market.mashape.com/sendible/sendible#uniqueservices-fetch
Sendible.Connect.getUniqueServices = function (params, onSuccess, onError) {
  return $.ajax({
    url: `${api_url}/api/v2/unique_accounts.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.saveMessage = function (application_id1, username, password, message, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  sendible_application_id = application_id;

  if (message.message_id != null && message.message_id > 0) { // let's do an update...
    message.method = 'PUT';
  } else if (typeof message.message_id === 'undefined') {
    message.method = 'POST';
  }

  return $.post(`${api_url}/1.2/api/message?${loginContext.getLoginContextForAPI()}`, message, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.init = function (logout_url) {
  const { hash } = window.location;
  let fields;
  let keyvals;

  if (hash == null || hash == '') {
    window.location = logout_url;
  } else {
    fields = hash.toString().split(',');

    for (let f = 0; f < fields.length; f++) {
      keyvals = fields[f].split('=');

      if (keyvals[0] == '#username') {
        sendible_login = keyvals[1];
      } else if (keyvals[0] == 'api_key') {
        sendible_api_key = keyvals[1];
      }
    }
  }
};

// -------------Shorten URLs Method---------------
Sendible.Connect.shorten_URL = function (application_id1, username, password, url, guid, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/shorten.json?${loginContext.getLoginContextForAPI()}`, { application_id, url, guid }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// -------------Shorten multiple URLs Method---------------
Sendible.Connect.shorten_URLs = function (application_id1, username, password, urls) {
  const application_id = Sendible.getApplicationId();
  const shortenedUrls = [];
  const url = urls[0];

  return Sendible.Connect.shorten_URL(
    application_id,
    username,
    password,
    url,
    (data) => {
      shortenedUrls.push(data.url);
      urls.pop();
    },
    () => {

    },
  );
};

Sendible.Connect.getVideoMetaData = function (application_id1, username, password, url, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v2/videometadata.json?${loginContext.getLoginContextForAPI(null, true)}`, { application_id, url }, (data) => {
    onSuccess(data);
  }).fail((data) => {
    onError(data);
  });
};

// -------------Get Link Preview Method---------------
Sendible.Connect.getLinkPreview = function (application_id1, username, password, url, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/1.0/api/linkpreview?${loginContext.getLoginContextForAPI(null, true)}`, { application_id, url }, (data) => {
    onSuccess(data);
  }).fail((data) => {
    onError(data);
  });
};

Sendible.Connect.getPreviewImages = function (application_id1, username, password, url, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v0/linkpreview.json?${loginContext.getLoginContextForAPI(null, true)}`, { application_id, url }, (data) => {
    onSuccess(data);
  }).fail((data) => {
    onError(data);
  });
};

// Get RSS Feeds
Sendible.Connect.fetchRSSFeeds = function (application_id1, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v2/rssfeeds?${loginContext.getLoginContextForAPI()}`, {
    application_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// Get Searches from table
Sendible.Connect.searches = function (application_id1, username, password, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v2/search?${loginContext.getLoginContextForAPI()}`, {
    application_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.fetchSocialCalendar = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  let context;

  params.application_id = application_id;

  if (params.forDefaultUserOnly) {
    context = loginContext.getLoginContextForAPI(null, true);
    delete params.forDefaultUserOnly;
  } else {
    context = loginContext.getLoginContextForAPI();
  }

  return $.ajax({
    url: `${api_url}/api/v3/social_calendar.json?${context}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    cache: false,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// Get Messages Function
Sendible.Connect.fetchMessages = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  let context;

  params.application_id = application_id;

  if (params.forDefaultUserOnly) {
    context = loginContext.getLoginContextForAPI(null, true);
    delete params.forDefaultUserOnly;
  } else {
    context = loginContext.getLoginContextForAPI();
  }

  return $.ajax({
    url: `${api_url}/1.2/api/messages?${context}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    cache: false,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.getMessage = function (application_id1, username, password, message_id, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();

  return $.getJSON(`${api_url}/1.2/api/message?${loginContext.getLoginContextForAPI()}&application_id=${application_id}`, {
    message_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

/** ****************
Use this method to retrieve message by message id and user id, if user_id is known.
***************** */
Sendible.Connect.getMessageByUserId = function (application_id1, username, password, message_id, user_id, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/1.2/api/message?${loginContext.getLoginContextForAPI()}&application_id=${application_id}`, {
    message_id,
    user_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getMessageRecipients = function (application_id1, username, password, message_id, user_id, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/message_recipients?${loginContext.getLoginContextForAPI()}&application_id=${application_id}`, {
    message_id,
    user_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// ----- Delete a sent/pending/draft message ------------------
Sendible.Connect.deleteMessage = function (application_id1, username, password, message_id, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/1.2/api/message?${loginContext.getLoginContextForAPI()}&method=DELETE`, {
    application_id,
    message_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.updateMessage = function (application_id1, username, password, message, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  message.application_id = application_id;

  return $.getJSON(`${api_url}/1.2/api/message?${loginContext.getLoginContextForAPI()}&method=PUT`, message, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// add in pages and per_page
Sendible.Connect.getMessageReports = function (application_id1, username, password, page, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/message-reports.json?${loginContext.getLoginContextForAPI()}`, {
    application_id,
    page,
    per_page: 10,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getMessageReport = function (application_id1, username, password, report_id, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/message-report.json?${loginContext.getLoginContextForAPI()}`, {
    application_id,
    report_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// --- Account Reports ---
Sendible.Connect.getAccountDetails = function (application_id1, username, password, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/account-details.json?${loginContext.getLoginContextForAPI()}`, {
    application_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getAccountPeriods = function (application_id1, username, password, account_detail_id, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/account-periods.json?${loginContext.getLoginContextForAPI()}`, {
    account_detail_id,
    application_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getAccountPosts = function (application_id1, username, password, account_detail_id, account_statistic_id, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/account-posts.json?${loginContext.getLoginContextForAPI()}`, {
    account_detail_id,
    account_statistic_id,
    application_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getAccountStatistics = function (application_id1, username, password, account_detail_id, yearmonth, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v1/account-statistics.json?${loginContext.getLoginContextForAPI()}`, {
    account_detail_id,
    yearmonth,
    application_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// --- Priority Inbox ---
Sendible.Connect.getPriorityInbox = function (application_id1, username, password, page, filter, include_archive, account_detail_ids, start, end, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {
    filter,
    include_archive: (typeof include_archive === 'undefined') ? 0 : include_archive,
    page,
    per_page: 20,
    start,
    end,
    application_id,
  };

  if (account_detail_ids) {
    params.account_detail_ids = account_detail_ids;
  }

  return $.ajax({
    url: `${api_url}/api/v1/priority-posts.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    cache: false,
    success(data) {
      if (onSuccess) {
        onSuccess(data);
      }
    },
    error(data) {
      if (onError) {
        onError(data);
      }
    },
  });
};

Sendible.Connect.createPriorityReply = function (application_id1, username, password, messageParams, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  messageParams.application_id = application_id;

  return $.ajax({
    dataType: 'json',
    type: 'POST',
    url: `${api_url}/api/v1/priority-post-reply.json?${loginContext.getLoginContextForAPI()}`,
    data: messageParams,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.deletePriorityPost = function (application_id1, username, password, messageParams, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  messageParams.application_id = application_id;
  messageParams.method = 'DELETE';

  return $.getJSON(`${api_url}/api/v2/priority_post.json?${loginContext.getLoginContextForAPI()}`, messageParams, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.loadPriorityPostConversation = function (application_id1, username, password, messageParams, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  messageParams.application_id = application_id;

  const successPart = function (data) {
    if (data.error != null) {
      if (onError != null) {
        onError(data.error.message);
      }
    } else {
      data.application_id = messageParams.application_id;
      data.username = messageParams.username;
      data.api_key = messageParams.api_key;

      Sendible.Connect.streamResponse(application_id1, username, password, data, function (streamData) {
        if (streamData.messages && streamData.messages.length > 0 && streamData.messages[0].error) {
          onError(streamData.messages[0]);
        } else {
          // NOTE: Hack is in place to convert fb tag in comments to proper
          // fb tag code used in dashboard. Once ruby is upgraded this logic
          // should be done on the backend

          // check if comments have message_tags information
          Sendible.applyFBTags(streamData);

          Sendible.Connect.dataParse(streamData, onSuccess, onError, this);
        }
      }, (streamData) => {
        onError(streamData);
      }, data.endpoint);
    }
  };
  const errorPart = function (data) {
    onError(data);
  };

  $.ajax({
    dataType: 'json',
    url: `${api_url}/api/v2/priority_post_conversation_params.json?${loginContext.getLoginContextForAPI()}`,
    data: messageParams,
    success: successPart,
    error: errorPart,
  });
};

// --- Message Streams ---
Sendible.Connect.getStreamAccounts = function (application_id1, username, password, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();

  return $.getJSON(`${api_url}/api/v1/stream-accounts.json?${loginContext.getLoginContextForAPI()}`, {
    application_id,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getStream = function (application_id1, username, password, accountParams, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  accountParams.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/stream_fetch?${loginContext.getLoginContextForAPI()}`, accountParams, function (data) {
    Sendible.applyFBTags(data);

    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    if (onError) {
      onError(data);
    } else {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    }
  });
};

Sendible.Connect.saveStreamItem = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'POST';

  return $.ajax({
    dataType: 'json',
    type: 'POST',
    url: `${api_url}/api/v2/stream_item?${loginContext.getLoginContextForAPI()}`,
    data: params,
    // dataType: "json",
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/*
Look up stream items - pass in comma separated list of uuids (identifiers) and account_id.
*/
Sendible.Connect.fetchSavedStreamItems = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/stream_item?${loginContext.getLoginContextForAPI()}`,
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.streamResponse = function (application_id1, username, password, responseParams, onSuccess, onError, endpoint) {
  const application_id = Sendible.getApplicationId();
  let api_endpoint = '/v2/post_action';
  responseParams.application_id = application_id;

  if (endpoint) {
    api_endpoint = endpoint;
  }

  return $.ajax(
    {
      type: 'GET',
      url: `${api_url}/api${api_endpoint}?${loginContext.getLoginContextForAPI()}`,
      data: responseParams,
      dataType: 'json',
      success(data) {
        Sendible.Connect.dataParse(data, onSuccess, onError, this);
      },
      error(data) {
        Sendible.Connect.dataParse(data, onSuccess, onError, this);
      },
    },
  );
};

Sendible.Connect.getStreamPost = function (application_id1, username, password, account_id, handle, stream, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  return $.getJSON(`${api_url}/api/v2/post_fetch?${loginContext.getLoginContextForAPI()}`, {
    application_id,
    account_id,
    handle,
    stream,
  }, function (data) {
    Sendible.applyFBTags(data);
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getPosterProfile = function (application_id1, username, password, posterParams, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  posterParams.application_id = application_id;

  return $.getJSON(`${api_url}/api/v0/profile.json?${loginContext.getLoginContextForAPI()}&ver=2`, posterParams, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    if (onError) {
      onError(data);
    } else {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    }
  });
};

Sendible.Connect.getBestTimeToPost = function (application_id1, username, password, weekday, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();

  return $.getJSON(`${api_url}/api/v2/best_time_to_post.json?${loginContext.getLoginContextForAPI()}`, {
    application_id,
    weekday,
  }, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

/*
*
*/
Sendible.Connect.getUsers = function (application_id1, username, password, onSuccess, onError, params) {
  const application_id = Sendible.getApplicationId();
  params = params || {};
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v0/users.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getUsersV2 = function (application_id1, username, password, onSuccess, onError, params) {
  const application_id = Sendible.getApplicationId();
  params = params || {};
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/users.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getMediaLibraries = function (application_id1, username, password, onSuccess, onError, params) {
  const application_id = Sendible.getApplicationId();
  params = params || {};
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v3/workspaces/media/libraries.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GetSubscriptionInfo : GET : https://code.google.com/p/sendible-api/wiki/GetSubscriptionInfo { application_id, details }
Sendible.Connect.getSubscriptionInfo = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/subscription_info.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// These properties are used in the userStats function and are set on the
// Connect object as they need to persist.

// whilst a userStats call is pending this will be true
Sendible.Connect.isCallingUserStats = false;

// the parameters currently used for the pending call will be
// cached in this property
Sendible.Connect.callingWithParams = null;

// the following 2 property arrays will cache all user stats calls made whilst
// a user stats call is already pending
Sendible.Connect.arUniqueUserStatsCalls = [];
Sendible.Connect.arIdenticalUserStatsCalls = [];
// arUniqueUserStatsCalls caches calls that have DIFFERENT params to current
// pending userStats call.
// arIdenticalUserStatsCalls caches calls that have the SAME params to current
// pending userStats call.
Sendible.Connect.accountVerification = function (onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {
    application_id,
    method: 'POST',
  };
  return $.ajax({
    type: 'POST',
    url: `${api_url}/1.0/api/account_verification/resend?${loginContext.getLoginContextForAPI()}`,
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};
Sendible.Connect.userStats = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.dashboard_version = window.dashboard_version;

  if (Sendible.Connect.isCallingUserStats) {
    if (_.isEqual(params, Sendible.Connect.callingWithParams)) {
      Sendible.Connect.arIdenticalUserStatsCalls.push({
        params,
        onSucess: onSuccess,
        onError,
      });
    } else {
      Sendible.Connect.arUniqueUserStatsCalls.push({
        params,
        onSucess: onSuccess,
        onError,
      });
    }
  } else {
    Sendible.Connect.isCallingUserStats = true;
    Sendible.Connect.callingWithParams = params;

    return $.ajax({
      type: 'get',
      url: `${api_url}/1.4/api/user_stats?${loginContext.getLoginContextForAPI()}`,
      data: params,
      success(data) {
        let previousUserStatsCall;
        let prevIdenticalCallsLength = 0;
        let prevUniqueCallsLength = 0;
        let i = 0;

        Sendible.Connect.dataParse(data, onSuccess, onError, this);
        Sendible.Connect.isCallingUserStats = false;

        prevUniqueCallsLength = Sendible.Connect.arUniqueUserStatsCalls.length;
        prevIdenticalCallsLength = Sendible.Connect.arIdenticalUserStatsCalls.length;

        if (prevIdenticalCallsLength) {
          // loop thru all cached userStats calls that had identical params
          // and pass response routine
          for (i; i < prevIdenticalCallsLength; i++) {
            previousUserStatsCall = Sendible.Connect.arIdenticalUserStatsCalls.shift();

            Sendible.Connect.dataParse(data, previousUserStatsCall.onSuccess, previousUserStatsCall.onError, this);
          }
        }

        if (prevUniqueCallsLength) {
          // if params different to the params just used to return the current
          // results then fire user stats again
          previousUserStatsCall = Sendible.Connect.arUniqueUserStatsCalls.shift();

          Sendible.Connect.userStats(
            application_id,
            null,
            null,
            previousUserStatsCall.params,
            previousUserStatsCall.onSuccess,
            previousUserStatsCall.onError,
          );
        }
      },
      error(data) {
        Sendible.Connect.isCallingUserStats = false;
        if (onError) {
          onError(data);
        } else {
          Sendible.Connect.dataParse(data, onSuccess, onError, this);
        }
      },
    });
  }
};

/**
 * Retrieves all queues for a given user.
 * @param  {[int]} application_id
 * @param  {[string]} username
 * @param  {[string]} password
 * @param  {[object]} params
 * @param  {[function]} onSuccess
 * @param  {[function]} onError        [
 * @return {[void]}
 */
Sendible.Connect.getQueues = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/1.0/api/queues?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

/**
 * Retrieves a specific queue.
 * @param  {[type]} application_id [description]
 * @param  {[type]} username       [description]
 * @param  {[type]} password       [description]
 * @param  {[type]} params         [Include queue_id]
 * @param  {[type]} onSuccess      [description]
 * @param  {[type]} onError        [description]
 * @return {[type]}                [description]
 */
Sendible.Connect.getQueue = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/1.0/api/queue?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.saveQueue = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'POST';

  if (params.queue_id) {
    params.method = 'PUT';
  }

  return $.ajax({
    type: 'POST',
    url: `${api_url}/1.0/api/queue?${loginContext.getLoginContextForAPI()}`,
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.deleteQueue = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'DELETE';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/1.0/api/queue?${loginContext.getLoginContextForAPI()}`,
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// Params: Include an array of message ID's in the order they should be saved.
Sendible.Connect.updateQueueOrder = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'PUT';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/queue_order?${loginContext.getLoginContextForAPI()}`,
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/*
* Get Tasks
* Params: assigned_to => me or others, status => Assigned, Approved,
*/
Sendible.Connect.getTasks = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.encode = true;
  return $.getJSON(`${api_url}/1.2/api/tasks?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.saveTaskComment = function (application_id1, username, password, taskIds, comment, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};

  params.application_id = application_id;
  params.method = 'PUT';
  params.task_ids = taskIds;
  params.a = 'comment';
  params.note = comment;
  params.encode = true;

  return $.getJSON(`${api_url}/api/v2/task.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

/*
Delete Tasks
*/
Sendible.Connect.deleteTasks = function (application_id1, username, password, taskIds, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};

  params.application_id = application_id;
  params.task_ids = taskIds;
  params.method = 'DELETE';

  return $.getJSON(`${api_url}/1.1/api/tasks?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

/*
Create Tasks
*/
Sendible.Connect.newTask = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'POST';

  // params are: stats (Assigned), task_type (e.g. received etc), note, identifier
  return $.getJSON(`${api_url}/api/v2/task.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.updateTask = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'PUT';

  return $.getJSON(`${api_url}/1.1/api/tasks?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

/*
* Set Task Status in bulk
* Params:
*/
Sendible.Connect.updateTaskStatus = function (application_id1, username, password, task_ids, status, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};

  params.application_id = application_id;
  params.task_ids = task_ids;
  params.status = status;
  params.method = 'PUT';

  return $.getJSON(`${api_url}/1.1/api/tasks?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// Loads the MeasureTab via the old version of Sendible.
Sendible.Connect.loadMeasureTab = function (application_id1, username, password, onSuccess, onError) {
  // const application_id = Sendible.getApplicationId();
  const params = {};
  const url = `${api_url}/analytics/print?live=true&access_key=1e4cde22b70ba03289476bf8fea15f8a641b2ff5&type=dashboard66104&custom_report_id=66104&days=30`;

  params.username = username;
  params.api_key = password;

  return $.ajax({
    url,
    type: 'GET',
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.updateStoryFeed = function (application_id1, username, password, feedid, feedName, feedURL, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};

  params.feed_id = feedid;
  params.feed_name = feedName;
  params.feed_url = feedURL;
  params.method = 'PUT';
  params.application_id = application_id;

  $.ajax({
    url: `${api_url}/api/v2/story_feed?${loginContext.getLoginContextForAPI()}`,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.createStoryFeed = function (application_id1, username, password, feedName, feedURL, feedType, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {
    feed_name: feedName,
    feed_url: feedURL,
    feed_type: feedType,
  };

  params.application_id = application_id;

  $.ajax({
    url: `${api_url}/api/v2/story_feed?${loginContext.getLoginContextForAPI()}`,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.deleteStoryFeed = function (application_id1, username, password, feedid, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};

  params.feed_id = feedid;
  params.method = 'DELETE';
  params.application_id = application_id;

  const queryURL = `${api_url}/api/v2/story_feed?${loginContext.getLoginContextForAPI()}`;

  $.ajax({
    url: queryURL,
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.getStoryFeed = function (application_id1, username, password, search, feed_type, total, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};

  params.search = search;
  params.feed_type = feed_type;
  params.application_id = application_id;

  if (total) {
    params.total = total;
  }

  $.ajax({
    url: `${api_url}/api/v2/story_feed?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    dataType: 'json',
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/**
 * Import a job into Sendible.
 * @param  {[type]} application_id [description]
 * @param  {[type]} username       [description]
 * @param  {[type]} password       [description]
 * @param  {[type]} params         [Consists of payload (CSV data), properties, type (type is messages or contacts)]
 * @param  {[type]} onSuccess      [description]
 * @param  {[type]} onError        [description]
 * @return {[type]}                [description]
 */
Sendible.Connect.importPayload = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/1.1/api/import?${loginContext.getLoginContextForAPI()}`,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/**
 * http://sendible.com/api/v2/media.json Connect methods (Tom Boyd)
 */

Sendible.Connect.getMedia = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/media.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};
/// api/v3/workspaces/media/library/assets
Sendible.Connect.getMediaNewAssets = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v3/workspaces/media/libraries/assets.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};
// UploadMedia : POST : https://code.google.com/p/sendible-api/wiki/UploadMedia { application_id, media }
Sendible.Connect.uploadMedia = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/media.json?${loginContext.getLoginContextForAPI()}` /* "&callback=?" */,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// UpdateMedia : POST : https://code.google.com/p/sendible-api/wiki/UpdateMedia { application_id, media }
Sendible.Connect.updateMedia = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/media.json?${loginContext.getLoginContextForAPI()}`,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// DeleteMedia : DELETE : https://code.google.com/p/sendible-api/wiki/DeleteMedia { application_id, file_id }
Sendible.Connect.deleteMedia = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'DELETE';
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/media.json?${loginContext.getLoginContextForAPI()}`,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/**
 * http://sendible.com/api/v2/account.json Connect methods (Gavin Hammar)
 */

Sendible.Connect.getAccountLoggedInUser = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/account.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.getAccount = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/account.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.getAccountV3 = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v3/account.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.getServiceUrl = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v3/service_urls.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// savelibrary
Sendible.Connect.saveLibrary = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = params.content_library_id ? 'PUT' : 'POST';
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/content_library.json?${loginContext.getLoginContextForAPI()}`,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

// deletelibrary
Sendible.Connect.deleteLibrary = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'DELETE';
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/content_library.json?${loginContext.getLoginContextForAPI()}`,
    type: 'POST',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/**
 * http://sendible.com/api/v2/content_library.json Connect methods (Gavin Hammar)
 */
Sendible.Connect.getContentLibrary = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/content_libraries.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/**
 * http://sendible.com/api/v2/content_libraries.json Connect methods (Gavin Hammar)
 */
Sendible.Connect.getContentLibraries = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.ajax({
    url: `${api_url}/api/v2/content_libraries.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

/**
 * http://sendible.com/api/v2/content_libraries.json Connect methods (Gavin Hammar)
 */
Sendible.Connect.urlStatus = function (application_id1, params, onSuccess, onError) {
  return $.ajax({
    url: `${api_url}/api/v0/urlstatus.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: params,
    dataType: 'json',
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.proxyUrlJson = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/proxy_url?${loginContext.getLoginContextForAPI(null, true)}`, params, (data) => {
    onSuccess(data); // Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail((data) => {
    onError(data); // Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

/* List API calls */

// GET LISTS (Get all lists for user): https://code.google.com/p/sendible-api/wiki/GetLists
Sendible.Connect.getLists = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/lists.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GET LIST (Specific list information): https://code.google.com/p/sendible-api/wiki/GetList
Sendible.Connect.getList = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/list.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// CREATE LIST: https://code.google.com/p/sendible-api/wiki/CreateList
Sendible.Connect.createList = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/list.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// UPDATE LIST: https://code.google.com/p/sendible-api/wiki/UpdateList
Sendible.Connect.updateList = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/list.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.deleteList = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'DELETE';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/list.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getListItems = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/list_items.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.addServiceToList = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/list_add.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.removeServiceFromList = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/list_remove.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.moveListItem = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/list_move.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// ListMemberOf : GET : https://code.google.com/p/sendible-api/wiki/ListMemberOf { application_id, item_id }
Sendible.Connect.listMemberOf = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'GET';
  params.application_id = application_id;

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/lists_member_of.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// ListsNotMemberOf : GET : https://code.google.com/p/sendible-api/wiki/ListsNotMemberOf { application_id, item_id }
Sendible.Connect.listsNotMemberOf = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'GET';
  params.application_id = application_id;

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/lists_not_member_of.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// GetPermissionCategories : GET : https://code.google.com/p/sendible-api/wiki/GetPermissionCategories { application_id }
Sendible.Connect.permissionCategories = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/permission_categories.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GetAvailablePermissions : GET : https://code.google.com/p/sendible-api/wiki/GetAvailablePermissions { application_id, category_id }
Sendible.Connect.availablePermissions = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/available_permissions.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GetPermissionProfiles : GET : https://code.google.com/p/sendible-api/wiki/GetPermissionProfiles { application_id }
Sendible.Connect.permissionProfiles = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/permission_profiles.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// CreatePermissionProfile : POST : https://code.google.com/p/sendible-api/wiki/CreatePermissionProfile { application_id, profile_name }
Sendible.Connect.createPermissionProfile = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/permission_profile.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// UpdatePermissionProfile : PUT : https://code.google.com/p/sendible-api/wiki/UpdatePermissionProfile { application_id, profile_id, profile_name }
Sendible.Connect.updatePermissionProfile = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/permission_profile.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// DeletePermissionProfile : DELETE : https://code.google.com/p/sendible-api/wiki/DeletePermissionProfile { application_id, profile_id }
Sendible.Connect.deletePermissionProfile = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'DELETE';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/permission_profile.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GetPermissionProfile : GET : https://code.google.com/p/sendible-api/wiki/GetPermissionProfile { application_id, profile_id }
// Available permissions that can be assiugned to the profile
Sendible.Connect.permissionProfile = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/permission_profile.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GetPermissionsForAProfile : GET : https://code.google.com/p/sendible-api/wiki/GetPermissionsForAProfile { application_id, profile_id }
Sendible.Connect.permissionsForAProfile = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/permissions.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// AddPermissionsToAProfile : POST : https://code.google.com/p/sendible-api/wiki/AddPermissionsToAProfile { application_id, profile_id, permissions }
Sendible.Connect.addPermissionsToAProfile = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/permissions.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// feature tag endpoint /api/v2/features
Sendible.Connect.getFeatureTags = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v2/features.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GetUserByUserId
// To retrieve an existing user, make a GET call using basic authentication.

// URL:
// http://sendible.com/api/v2/user.json

// HTTP Methods:
// GET

// Parameters:
// application_id: Your application id from http://sendible.com/developers.
// The following parameters are optional. If they are not provided, then the authenticated user's details are used.

// user_id: The ID of the user to retrieve.
// user_api_key: The API key of the user to retrieve.
Sendible.Connect.GetUserByUserId = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'GET';

  return $.getJSON(`${api_url}/api/v2/user.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// User api calls
// CreatePermissionProfile : POST : https://code.google.com/p/sendible-api/wiki/CreatePermissionProfile { application_id, profile_name }
Sendible.Connect.createUser = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/user.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.updateUserPreferences = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/user_preferences.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.updateUser = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/user.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.enableOrDisableUser = function (application_id1, username, password, user_id, status, user_api_key, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};
  params.user_id = user_id;
  params.status = status;
  params.user_api_key = user_api_key;
  params.method = 'PUT';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/user.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.deleteUser = function (application_id1, username, password, user_id, user_api_key, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  const params = {};
  params.user_id = user_id;
  params.user_api_key = user_api_key;
  params.method = 'DELETE';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/user.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GET LIST (Specific list information): https://code.google.com/p/sendible-api/wiki/GetList
Sendible.Connect.getCustomFields = function (application_id1, username, password, params, onSuccess, onError) {
  /*
   * application_id: Your application id from http://sendible.com/developers.
   * category: The category of fields to retrieve. Valid values are user, contact or service.
   * To retrieve actual values for a given entity, include the following two optional parameters:

   * if include_values is set then set identifier (user_id) also
   * include_values: Set to true to include values for each field.
   * identifier: The ID of the entity to retrieve. This represents user_id, contact_id or service_id.
  */
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'GET';

  return $.getJSON(`${api_url}/api/v2/custom_fields.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// https://code.google.com/p/sendible-api/wiki/UpdateCustomFieldValue
Sendible.Connect.UpdateCustomFieldValue = function (application_id1, username, password, user_id, category, fieldValues, options, onSuccess, onError) {
  const params = {};
  const application_id = Sendible.getApplicationId();
  params.identifier = user_id;
  params.category = category;
  params.application_id = application_id;
  params.field_values = fieldValues;
  params.method = 'PUT';

  $.extend(params, options);

  // useApiKey, useToken
  return $.post(`${api_url}/api/v2/custom_fields.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// https://code.google.com/p/sendible-api/wiki/UpdateCustomFieldOrder
Sendible.Connect.UpdateCustomFieldsOrder = function (application_id1, username, password, category, custom_field_ids, onSuccess, onError) {
  const params = {};
  const application_id = Sendible.getApplicationId();
  params.category = category;
  params.application_id = application_id;
  params.custom_field_ids = custom_field_ids;
  params.method = 'PUT';

  return $.post(`${api_url}/api/v2/custom_field_order.json?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// https://code.google.com/p/sendible-api/wiki/UpdateCustomField
Sendible.Connect.customField = function (application_id1, username, password, fieldOptions, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  fieldOptions.application_id = application_id;

  return $.post(`${api_url}/api/v2/custom_field.json?${loginContext.getLoginContextForAPI()}`, fieldOptions, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// https://www.mashape.com/sendible/sendible#topic-create
Sendible.Connect.createTopic = function (param, onSuccess, onError) {
  return $.post(`${api_url}/api/v2/topic.json?${loginContext.getLoginContextForAPI()}`, param, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// https://www.mashape.com/sendible/sendible#topic-delete
Sendible.Connect.deleteTopic = function (param, onSuccess, onError) {
  param.method = 'DELETE';

  return $.post(`${api_url}/api/v2/topic.json?${loginContext.getLoginContextForAPI()}`, param, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.passwordReset = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;
  params.method = 'GET';

  return $.getJSON(`${api_url}/api/v3/password_reset?`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.passwordSet = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v3/password_reset?`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.loginMethod = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.post(`${api_url}/api/v2/auth?`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// GetReceipts : GET : https://code.google.com/p/sendible-api/wiki/GetReceipts { application_id }
Sendible.Connect.getReceipts = function (application_id1, params, onSuccess, onError) {
  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/receipts.json?${loginContext.getLoginContextForAPI(null, true)}`,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// GetReceipts : GET : https://code.google.com/p/sendible-api/wiki/GetReceipts { application_id (api_key) }
Sendible.Connect.updateReceiptInfo = function (application_id1, params, onSuccess, onError) {
  params.method = 'PUT';

  return $.post(`${api_url}/api/v2/receipts.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// CreateSupportTicket : POST : https://code.google.com/p/sendible-api/wiki/CreateSupportTicket { application_id, subject, message, mode }
Sendible.Connect.createSupportTicket = function (application_id1, params, onSuccess, onError) {
  params.method = 'POST';

  return $.post(`${api_url}/api/v2/support_ticket.json?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getCompany = function (application_id1, onSuccess, onError) {
  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/company.json?${loginContext.getLoginContextForAPI(null, true)}`,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.updateCompany = function (application_id1, username, password, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.post(`${api_url}/1.0/api/company_preferences?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }, 'json').fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// AccountCancellation : POST : https://code.google.com/p/sendible-api/wiki/AccountCancellation { application_id, reason }
Sendible.Connect.accountCancellation = function (application_id1, params, onSuccess, onError) {
  params.method = 'POST';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/account_cancellation.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.queryTwitterHashtag = function (query, onSuccess, onError) {
  query = `#${query}`;
  const url = `https://twitter.com/i/search/typeahead.json?count=10&filters=true&q=${encodeURIComponent(query)}&result_type=topics&src=COMPOSE&callback=?`;

  $.getJSON(
    url,
    function (data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  ).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// SocialProfileSearch : GET : https://code.google.com/p/sendible-api/wiki/SocialProfileSearch { application_id, type, account_id, q }
Sendible.Connect.socialProfileSearch = function (application_id1, params, onSuccess, onError) {
  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/social_profile_search.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// SaveContactAccounts : GET : https://code.google.com/p/sendible-api/wiki/SaveContactAccounts { application_id, contact_id, type, account_id, profile_id, profile_url, profile_picture, full_name, profile_name }
Sendible.Connect.SaveContactAccounts = function (application_id1, params, onSuccess, onError) {
  params.method = 'PUT';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/contact_account.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// ServiceGroups : GET : https://code.google.com/p/sendible-api/wiki/GetServiceGroups { application_id, category_code }
Sendible.Connect.serviceGroups = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  // the getLoginContextForAPI provides the correct username, api_key
  // hence we delete them from the params
  delete params.username;
  delete params.api_key;

  return $.ajax({
    type: 'GET',
    url: `${api_url}/1.0/api/service_groups?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// ServiceGroups : GET : https://code.google.com/p/sendible-api/wiki/GetServiceGroups { application_id, category_code }
Sendible.Connect.serviceTypes = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  // the getLoginContextForAPI provides the correct username, api_key
  // hence we delete them from the params
  delete params.username;
  delete params.api_key;

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/service_types.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// GetServices : GET : https://code.google.com/p/sendible-api/wiki/GetServices { application_id, filter, per_page, page }
Sendible.Connect.getSharedServicesList = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/shared_with_me.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// GetServices : GET : https://code.google.com/p/sendible-api/wiki/GetServices { application_id, filter, per_page, page }
Sendible.Connect.getServicesList = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/accounts.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// getNotifications : GET : https://code.google.com/p/sendible-api/wiki/GetNotifications
Sendible.Connect.getNotifications = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/notifications.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      if (onError) {
        onError(data);
      }
      // Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.UpdateNotification = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/notifications.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// CreateAccount : POST : https://code.google.com/p/sendible-api/wiki/CreateAccount { application_id, account_id, description, parameters }
Sendible.Connect.createAccount = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/account.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// UpdateAccount : PUT : https://code.google.com/p/sendible-api/wiki/UpdateAccount { application_id, account_id, description, parameters }
Sendible.Connect.updateAccount = function (application_id1, params, onSuccess, onError) {
  params.method = 'PUT';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/account.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// DeleteAccount : DELETE : https://code.google.com/p/sendible-api/wiki/DeleteAccount { application_id, account_id }
Sendible.Connect.deleteAccount = function (application_id1, params, onSuccess, onError) {
  params.method = 'DELETE';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/account.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// Retrieve shared users for a selected service:
// http://WEBPACK_API/api/v0/users-shared?type=shared&user_id=[USER_ID]&entity=service&entity_identifier=[SELECTED_ID]
// Retrieve unshared users for a selected service:
// http://WEBPACK_API/api/v0/users-shared?type=unshared&user_id=[USER_ID]&entity=service&entity_identifier=[SELECTED_ID]
// UsersShared : GET : https://code.google.com/p/sendible-api/wiki/UsersShared { application_id, type, entity, entity_identifier }
Sendible.Connect.usersShared = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v0/users-shared.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// Retrieve all shareable items for a user:
// http://WEBPACK_API/api/v0/shareable-items?user_id=[USER_ID]&code=service
Sendible.Connect.shareableItems = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v0/shareable-items.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// Share one or more items
// http://WEBPACK_API/api/v0/share?user_id=5131&user_ids=139106%2C164411&entity=service&entity_identifier=840830&event=add
// Unshare one or more items
// http://WEBPACK_API/api/v0/share?user_id=5131&user_ids=164411&entity=service&entity_identifier=840830&event=remove
Sendible.Connect.shareItems = function (application_id1, params, onSuccess, onError) {
  params.method = 'GET';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v0/share.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// ShareService : POST : https://code.google.com/p/sendible-api/wiki/xx { application_id, account_id, contributors }
Sendible.Connect.shareService = function (application_id1, params, onSuccess, onError) {
  params.method = 'POST';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/share_service.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse({ error: JSON.parse(data.responseText) }, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// UnShareService : POST : https://code.google.com/p/sendible-api/wiki/xx { application_id, account_id, contributors }
Sendible.Connect.unShareService = function (application_id1, params, onSuccess, onError) {
  params.method = 'POST';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/unshare_service.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse({ error: JSON.parse(data.responseText) }, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// TransferAccount : POST : https://code.google.com/p/sendible-api/wiki/ShareAccount { application_id, account_id, to_user_id }
Sendible.Connect.transferAccount = function (application_id1, params, onSuccess, onError) {
  params.method = 'POST';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/account_transfer.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getTrialSettingsForWhiteLabel = function (application_id1, params, onSuccess, onError) {
  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/trial_settings.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.saveTrialSettingsForWhiteLabel = function (application_id1, params, onSuccess, onError) {
  params.method = 'PUT';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/trial_settings.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.addTimeToTrialUser = function (application_id1, params, onSuccess, onError) {
  params.method = 'PUT';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/trial_user_addtime.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// create a new trial user.
Sendible.Connect.createNewTrialUser = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/trial_user.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// I've added the api/v2/trial_user_upgrade endpoint
// call a PUT on there with the parameter trial_user_id to upgrade the user
Sendible.Connect.upgradeTrialUser = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/trial_user_upgrade.json?${loginContext.getLoginContextForAPI(null, true)}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getTimeZones = function (onSuccess, onError) {
  return $.getJSON(`${api_url}/api/utils/timezones.json?`, {}, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

// UpdateAccount : PUT : https://code.google.com/p/sendible-api/wiki/updateTimezone
Sendible.Connect.updateTimezone = function (application_id1, params, onSuccess, onError) {
  params.method = 'PUT';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/timezone.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// GetUrlParameterTempaltes : GET : https://code.google.com/p/sendible-api/wiki/GetUrlParameterTempaltes { application_id }
Sendible.Connect.getUrlParameterTempaltes = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'GET';
  params.application_id = application_id;

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/url_parameter_templates.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// DeleteUrlParameterTempalte : DELETE : https://code.google.com/p/sendible-api/wiki/DeleteUrlParameterTempalte { application_id }
Sendible.Connect.deleteUrlParameterTemplate = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'DELETE';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/url_parameter_template.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// CreateUrlParameterTemplate : POST : https://code.google.com/p/sendible-api/wiki/CreateUrlParameterTempaltes { application_id }
Sendible.Connect.createUrlParameterTemplate = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/url_parameter_template.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// UpdateUrlParameterTemplate : PUT : https://code.google.com/p/sendible-api/wiki/UpdateUrlParameterTemplate { application_id }
Sendible.Connect.updateUrlParameterTemplate = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/url_parameter_template.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getQuickReports = function (params, onSuccess, onError) {
  params.method = 'GET';
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/quick_reports.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getCustomReports = function (params, onSuccess, onError) {
  params.method = 'GET';
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/custom_reports.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getReportDashboards = function (params, onSuccess, onError) {
  params.method = 'GET';
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/dashboards.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getAvailableReportModules = function (params, onSuccess, onError) {
  params.method = 'GET';
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/available_report_modules.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getCampaigns = function (params, onSuccess, onError) {
  params.method = 'GET';
  params.application_id = Sendible.getApplicationId();
  params.status = 'active';

  return $.ajax({
    type: 'GET',
    url: `${api_url}/1.0/api/campaigns?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getCustomReport = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'GET';
  params.application_id = application_id;

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/custom_report.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      window.pendo.track('[Report hub] Report views', {
        id: data.id,
        type: 'quick report',
        network: data.account_type,
      });
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.createCustomReport = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/custom_report.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.UpdatePrintReportHeaderOption = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/custom_report_header_option.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.updateCustomReport = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/custom_report.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.deleteCustomReport = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'DELETE';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/custom_report.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.emailCustomReport = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'POST';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/custom_report_email.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.updateEmailCustomReportSettings = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/custom_report_email.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.updateCustomReportCoverPage = function (params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.method = 'PUT';
  params.application_id = application_id;

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/custom_report_cover_page.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

// ErrorLog : POST : https://code.google.com/p/sendible-api/wiki/ErrorLog { application_id, message, stacktrace, source, type }
Sendible.Connect.errorLog = function (application_id1, params, onSuccess, onError) {
  params.method = 'POST';

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/error_log.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error() {
      onError();
    },
    dataType: 'json',
  });
};

Sendible.Connect.getFeed = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v3/feed?${loginContext.getLoginContextForAPI()}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getFeedSearch = function (application_id1, params, onSuccess, onError) {
  const application_id = Sendible.getApplicationId();
  params.application_id = application_id;

  return $.getJSON(`${api_url}/api/v3/feed_search?${loginContext.getLoginContextForAPI(null, true)}`, params, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail(function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  });
};

Sendible.Connect.getAmazonCredentials = function (application_id1, params, onSuccess, onError) {
  $.ajax({
    url: `${api_url}/api/v2/aws_policy.json?${loginContext.getLoginContextForAPI()}`,
    type: 'GET',
    data: {},
    dataType: 'json',
    cache: false,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      if (onError) {
        onError(data);
      }
    },
  });
};

Sendible.Connect.getAnimatedGifStatus = function (media_file_url, onSuccess, onError) {
  return $.get(`${api_url}/api/v2/detect_animated_gif?${loginContext.getLoginContextForAPI()}&file_url=${encodeURIComponent(media_file_url)}`, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail((data) => {
    onError(data);
  });
};

Sendible.Connect.getMediaFileSize = function (media_file_url, onSuccess, onError) {
  return $.get(`${api_url}/api/v2/get_media_file_size?${loginContext.getLoginContextForAPI()}&media_file_url=${media_file_url}`, function (data) {
    Sendible.Connect.dataParse(data, onSuccess, onError, this);
  }).fail((data) => {
    onError(data);
  });
};

Sendible.Connect.createApplication = function (params, onSuccess, onError) {
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v2/application.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getApplication = function (params, onSuccess, onError) {
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/application.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.logout = function (params, onSuccess, onError) {
  if (!params) {
    params = {};
  }
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v3/logout.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.updateCustomer = function (params, onSuccess, onError) {
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'PUT',
    url: `${api_url}/api/v2/customer.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getRawFileData = function (params, onSuccess, onError) {
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/content_proxy.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
  });
};

Sendible.Connect.accountCount = function (params, onSuccess, onError) {
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v2/account_count.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.getPaymentMethod = function (params, onSuccess, onError) {
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'GET',
    url: `${api_url}/api/v3/payment_method.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};

Sendible.Connect.postWhiteLabelCancellation = function (params, onSuccess, onError) {
  params.application_id = Sendible.getApplicationId();

  return $.ajax({
    type: 'POST',
    url: `${api_url}/api/v3/white_label_cancellation.json?${loginContext.getLoginContextForAPI()}`,
    data: params,
    success(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    error(data) {
      Sendible.Connect.dataParse(data, onSuccess, onError, this);
    },
    dataType: 'json',
  });
};
